module.exports = "/packs/onbording_04-663f4e14b3aadc8defaf9935028685ff.jpg";